import React from "react";
import LeftNav from "../common/leftnav";
import CallAnalysis from "./call_analysis/callAnalysis";
import CallLogs from "./call_logs/callLogs";
import ProtectedRoute from "../common/ProtectedRoute";

const Overview = () => {
  return (
    <ProtectedRoute>
      <div className="d-flex">
        <LeftNav />
        <div className="dashboard-content flex-grow-1 p-4 bg-light">
          <h2 className="fs-five-title fw-bold ms-2">Overview</h2>
          <CallAnalysis />
          <CallLogs />
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default Overview;
